
import AppLink from "./AppLink.vue"
export default {
  components: {
    AppLink
  },
  props: {
    small: {
      type: Boolean,
      default: false
    },
    fontColor: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: null
    },
    link: {
      type: String,
      default: null
    },
    disableRouterBack: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      buttonLabel: this.label || "Back"
    }
  },
  computed: {
    backLinkClass() {
      return {
        "back-button": true,
        "is-small": this.small
      }
    }
  },
  methods: {
    backTo(e) {
      this.$emit("goBackTo")
      if (!this.link && !this.disableRouterBack) {
        this.$router.go(-1)
      }
    }
  }
}
